import React, {Component} from 'react';
import {Popconfirm, Button, message, Modal,Select,Tag,InputNumber} from 'antd';
import * as Types from '../../../../utils/questionType';

import axios from 'axios'
import {connect} from 'react-redux'
import API from '../../../../API/api'
import {PropTypes} from 'prop-types';

const {TYPE_MAP_VIEW, TYPE_SHOW_VIDEO,} = Types
const { CheckableTag } = Tag;
const Option = Select.Option
let well_chosen =
    {
        0: "普通题",
        1: "课后题",
        2: "扩展题"
    }

let well_chosen_english =
    {
        0: "默认",
        11: "基础题",
        12: "进阶题"
    }
class Question extends Component {
    state = {
        reworkModal: false,
        reworkMessage: [],
        showMore: true,
    }
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    //修改
    editQuestion = (question_id) => {
        window.open(window.location.origin + `/question.html#/questionmanage/fillin/${question_id}`)
    }
    //打标签
    setTagQuestion = (question_id) => {
        window.open(`${window.location.origin}#/questionmanage/lookoverquestion/setTag/${question_id}`);
        // this.context.router.history.push(`lookoverquestion/setTag/${question_id}`);
    }
    //删除
    delRelationship = () => {
        let {relate_id, type,refresh,changeListNoRefresh} = this.props.parent
        let question_id = this.props.question.question_id
        let data = {
            question_id,
            relate_id,
            type,
        }
        axios.post(API.DEL_QUESTION_RELATE, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success('删除关联成功')
                changeListNoRefresh(question_id)
                // refresh()

            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    delQuestion = () => {//删除题目
        let {refresh} = this.props.parent
        let question_id = this.props.question.question_id
        let data = {
            question_id,
        }
        axios.post(API.QIUESTION_LOOK_DEL_QUESTION, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success('删除题目成功')
                refresh()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    offlineOnlineQuestion = () => {//上下线题目
        let {refresh} = this.props.parent
        let question_id = this.props.question.question_id
        let data = {
            question_id,
        }
        let str ='题目上线成功'
        let URL= API.QIUESTION_LOOK_ONLINE_QUESTION
        if(this.props.question.online_status==2){
            str ='题目下线成功'
            URL= API.QIUESTION_LOOK_OFFLINE_QUESTION
        }
        axios.post(URL, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success(str)
                refresh()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    wellChosenChange = (val) => {//课后题 普通题选择
        let {section_id} = this.props.parent
        let question_id = this.props.question.question_id
        let data = {
            question_id,
            well_chosen:val,
            section_id,
        }
        axios.post(API.SET_QUESTION_WELLCHOSEN, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success('修改成功')
                this.forceUpdate()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    displayTypeChange = (val) => {//题目展示类型修改
        let {section_id} = this.props.parent
        let question_id = this.props.question.question_id
        let data = {
            question_id,
            display_type:val,
            // section_id,
        }
        axios.post(API.SET_QUESTION_DISPLAY_TYPE, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success('修改成功')
                // this.props.list[this.props.index].display_type=''+val
                this.props.question.display_type=''+val
                this.props.update()
                this.forceUpdate()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    userCheckChange = (val) => {//正确
        let question_id = this.props.question.question_id
        let data = {
            question_id,
            user_check:val,
        }
        axios.post(API.SET_QUESTION_USER_CHECK, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                this.props.question.user_check = val
                this.forceUpdate()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    isEvaluationChange = () => {//评测题
        let question_id = this.props.question.question_id
        let {section_id} = this.props.parent
        let val = (this.props.question.is_evaluation==='1')?'0':'1'
        let data = {
            question_id,
            is_evaluation:val,
            section_id
        }
        axios.post(API.SET_QUESTION_IS_EVALUATION, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                this.props.question.is_evaluation = val
                this.forceUpdate()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    delShoppingQuestion=(id) => {//购物车页面的删除
        let { delQuestion,refresh } = this.props.parent;
        delQuestion(id)
        setTimeout(()=>{
            refresh()
        },0)
    }
    canEdit=(type_show)=>{
    		
    		let disableEditQuestionType=[
    			Types.TYPE_SHOW_MULTISELECT,
    			Types.TYPE_SHOW_DECLAIM_RECITE,
	    		Types.TYPE_SHOW_VIDEO_SUB,
	    		Types.TYPE_SHOW_24POINTS,
	    		Types.TYPE_SHOW_VERTICAL,
	    		Types.TYPE_SHOW_DELIVERY,
	    		Types.TYPE_SHOW_SUDOKU,
	    		Types.TYPE_VERTICAL_SECOND,
	    		Types.TYPE_SHOW_AI_FIX_DRAG_FILLIN,
    			Types.TYPE_SHOW_AI_FIX_DRAG_SELECT,
    			// Types.TYPE_SHOW_AI_FIX_DRAG,
    			Types.TYPE_SHOW_AI_CLEAN_FILLIN,
    			Types.TYPE_SHOW_AI_CLEAN_SELECT,
    			Types.TYPE_SHOW_AI_UNFIX_DRAG_FILLIN,
    			Types.TYPE_SHOW_AI_UNFIX_DRAG_SELECT,
    			Types.TYPE_SHOW_AI_READ_NUMBER,
    		]
       if(disableEditQuestionType.includes(type_show)){
           return false
       }else{
           return true
       }
    }

    //排序值
    addScore = () => {
        let {relate_id, type,refresh} = this.props.parent
        let question_id = this.props.question.question_id
        let data = {
            question_id,
            source_id:relate_id,
            type,
            score:this.state.score,
        }
        axios.post(API.ADD_QUESTION_SCORE, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success('修改成功')
                this.props.question.score = this.state.score
                this.setState({scoreModal:false,score:''})
                refresh()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    // 切换显示更多按钮
    toggleTitle = () => {
        let showMore = !this.state.showMore;
        this.setState({showMore})
    }
    render() {
        let role_qshow = this.props.parent.role_qshow||false
        let question = this.props.question
        const {shopcar,addToCart,controlable=true} = this.props.parent
        if(question.type_show==Types.TYPE_SHOW_CN_READ){
        		well_chosen_english =
		    {
		        0: "默认",
		        13:"课内",
		        14:"课外"
		    }
        }else{
        		well_chosen_english =
		    {
		        0: "默认",
		        11: "基础题",
		        12: "进阶题"
		    }
        }
        return (
            <div style={{position: 'absolute', top: '0px', right: '20px'}} className={'editDel'}>
                {
                    controlable &&
                    <div className = "control">
                        {

                            role_qshow.editShopping>0&&(question.type_show!==TYPE_SHOW_VIDEO)&&
                            <Button  style={{display: 'block', marginBottom: 6}}
                                     type= {!shopcar.some(d=>d.question_id==question.question_id) ? "": "danger"}
                                     onClick= { () => addToCart(question.question_id,question.well_chosen) }>
                                {
                                    !shopcar.some(d=>d.question_id==question.question_id)? "加入已选": "取消已选"
                                }
                            </Button>
                        }
						 
                        {
                           role_qshow.editQuestion>0&&this.canEdit(question.type_show)&&
                           <Button style={{display: 'block', marginBottom: 6,width:'80px'}}
                                    onClick= { () => this.editQuestion(question.question_id) }>
                                改题
                            </Button>
                           
                        }
                        {
                            role_qshow.select>0&&(question.type_show!==TYPE_SHOW_VIDEO)&&
                            <Button style={{display: 'block', marginBottom: 6,width:'80px'}}
                                    onClick= { () => this.setTagQuestion(question.question_id) }>
                                打标签
                            </Button>
                        }

                        

                        {
                            role_qshow.delRelate>0 &&(question.type_show!==TYPE_SHOW_VIDEO)&&
                            <Popconfirm title="确认删除关联吗？" onConfirm={ () => this.delRelationship() } okText="确定" cancelText="取消">
                                <Button type="danger"style={{display: 'block', marginBottom: 6}}>删除关联</Button>
                            </Popconfirm>
                        }

                        
                        {
                            // role_qshow.rightQuestion>0 &&(question.type_show!==TYPE_SHOW_VIDEO)&&
                            // <Button  style={question.user_check=='1'?
                            //     {marginBottom:6,display: 'block',color:"#fff",background:'#108ee9',width:'80px'}:
                            //     {marginBottom:6,display: 'block',width:'80px'}}
                            //          onClick={() => {this.userCheckChange(question.user_check=='1'?'0':'1')}}>
                            //     { `正确` }
                            // </Button>
                        }
                        {
                            this.props.subject !=='1' && this.props.subject !=='2' && role_qshow.evalutionQuestion>0 &&(question.type_show!==TYPE_SHOW_VIDEO)&&
                            <Button  style={question.is_evaluation=='1'?
                                {marginBottom:6,display: 'block',color:"#fff",background:'#108ee9',width:'80px'}:
                                {marginBottom:6,display: 'block',width:'80px'}}
                                     onClick={(value) => {this.isEvaluationChange()}}>
                                { `评测题` }
                            </Button>
                        }

                        {/*课后题 普通题*/}
                        {
                            this.props.subject ==='0'&&this.props.product !='4'&&
                            role_qshow.wellChosen>0&&(question.type_show!==TYPE_SHOW_VIDEO)&&
                            question.well_chosen!=undefined?
                            (<Select style={{display: 'block',width:'80px',marginBottom:6,}} value={well_chosen[question.well_chosen]}
                                     className={ well_chosen[question.well_chosen]==='普通题'?
                                                '':
                                            well_chosen[question.well_chosen]==='课后题'?
                                                'blue':
                                                'green'
                                     }
                                     onChange={ (value) => {this.wellChosenChange(value,question.question_id);question.well_chosen=value}}>
                                {
                                    Object.keys(well_chosen).map((v1, k) =>
                                        <Option key={k} value={ v1 }>
                                            {
                                                well_chosen[v1]
                                            }
                                        </Option>
                                    )
                                }
                            </Select>):''
                        }

                        {/*基础题 进阶题*/}

                        {
                            this.props.subject ==='1'||this.props.subject ==='2'&&
                            role_qshow.wellChosen>0&&(question.type_show!==TYPE_SHOW_VIDEO)&&
                            question.well_chosen!=undefined?
                                (<Select style={{display: 'block',width:'80px',marginBottom:6,}} value={well_chosen_english[question.well_chosen]}
                                         className={ well_chosen_english[question.well_chosen]==='进阶题'?
                                             'blue':
                                             ''
                                         }
                                         onChange={ (value) => {this.wellChosenChange(value,question.question_id);question.well_chosen=value}}>
                                    {
                                        Object.keys(well_chosen_english).map((v1, k) =>
                                            <Option key={k} value={ v1 }>
                                                {
                                                    well_chosen_english[v1]
                                                }
                                            </Option>
                                        )
                                    }
                                </Select>):''
                        }
                        {/*展示题型*/}
                        {
                            this.props.subject ==='0' && role_qshow.editDisplayType>0&&(question.type_show!==TYPE_SHOW_VIDEO)&&
                            question.display_type!=undefined?
                                (<Select style={{display: 'block',width:'80px',marginBottom:6}} value={TYPE_MAP_VIEW[question.display_type]}

                                         onChange={ (value) => {this.displayTypeChange(value,question.question_id);question.display_type=value}}>

                                    {
                                        question.displaytypelist?
                                            question.displaytypelist.map((v1, k) =>
                                            <Option key={k} value={ v1.id }>
                                                {
                                                    v1.name
                                                }
                                            </Option>
                                        )
                                            :
                                            Object.keys(TYPE_MAP_VIEW).map((v1, k) =>
                                                <Option key={k} value={ v1 }>
                                                    {
                                                        TYPE_MAP_VIEW[v1]
                                                    }
                                                </Option>
                                            )
                                    }

                                </Select>):''
                        }
                        {
                            role_qshow.addScore>0 &&
                            <Button  style={{marginBottom:6,display: 'block',width:'80px'}}
                                     type={(question.score&&question.score>0)?'primary':''}
                                     onClick={()=>{this.setState({scoreModal:true,score:question.score||''})}}>
                                { `排序值` }
                            </Button>
                        }
                        {
                            <Modal title={question.score?'修改排序值':'输入排序值'} visible={this.state.scoreModal} onOk={this.addScore} onCancel={()=>this.setState({scoreModal:false})}>
                                排序值：<InputNumber onChange={(val)=>{if(val>=0){this.setState({score:val})} }} value={this.state.score}/>
                            </Modal>
                        }
                        

                        {
                            !this.state.showMore ? 
                                <div>
                                    {
                                        role_qshow.offlineQuestion>0 &&
                                        <Popconfirm title={question.online_status==2?'确认下线吗？':'确认上线吗？'} onConfirm={ () => this.offlineOnlineQuestion() } okText="确定" cancelText="取消">
                                            <Button style={{display: 'block', marginBottom: 6}}>{question.online_status==2?'暂时下线':'上线题目'}</Button>
                                        </Popconfirm>

                                    }
                                    {
                                        role_qshow.delQuestion>0 &&
                                        <Popconfirm title="删除后不可恢复，确认删除此题目吗？" onConfirm={ () => this.delQuestion() } okText="确定" cancelText="取消">
                                            <Button style={{display: 'block', marginBottom: 6}}>删除题目</Button>
                                        </Popconfirm>

                                    }
                                </div> : null
                        }
                        <Button
                            style={{marginBottom: 6,width:'80px'}}
                            onClick= {this.toggleTitle}>
                            {this.state.showMore ? '显示更多': '隐藏更多'}
                        </Button>
                    </div>
                }

            </div>
        )
    }
}

export default Question



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/editDelQuestionManage/view.js